import { useTranslation } from '../contexts/TranslationContext';

// Function to get translated tour steps
export const useTranslatedSteps = () => {
  const { t } = useTranslation();
  
  return {
    steps_channel: [
      {
        selector: '.first-step',
        content: t('steps.channel.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.channel.instagram.step2'),
      },
      {
        selector: '.third-step',
        content: t('steps.channel.telegram.step1'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.channel.website.step1'),
      },
      {
        selector: '.fifth-step',
        content: t('steps.channel.bale.step1'),
      },
    ],

    steps_knowledge: [
      {
        selector: '.first-step',
        content: t('steps.knowledge.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.knowledge.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.knowledge.step2'),
      },
      {
        selector: '.fourth-step',
        content: (
          <div style={{ textAlign: 'center', maxWidth: '300px' }}>
            <img 
              src="/images/deleteKnowledge.png" 
              alt="Knowledge Management" 
              style={{ 
                width: '300px', 
                height: '100px', 
                borderRadius: '8px',
                marginBottom: '16px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                display: 'block',
                margin: '0 auto 16px auto'
              }} 
            />
            <p style={{ 
              margin: 0, 
              fontSize: '14px', 
              lineHeight: '1.5',
              textAlign: 'right',
              direction: 'rtl'
            }}>
              {t('steps.knowledge.step3')}
            </p>
          </div>
        ),
      },
    ],

    steps_profile: [
      {
        selector: '.first-step',
        content: t('steps.profile.title'),
      },
    ],
    steps_profile_onboarding: [
      {
        selector: '.first-step',
        content: t('steps.profile_onboarding.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.profile_onboarding.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.profile_onboarding.step2'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.profile_onboarding.step3'),
      },
    ],

    steps_payments: [
      {
        selector: '.first-step',
        content: t('steps.payments.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.payments.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.payments.step2'),
      },
    ],
    
    steps_business: [
      {
        selector: '.first-step',
        content: t('steps.business.title'),
      },
    ],
    steps_business_onboarding: [
      {
        selector: '.first-step',
        content: t('steps.business_onboarding.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.business_onboarding.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.business_onboarding.step2'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.business_onboarding.step3'),
      },
      {
        selector: '.fifth-step',
        content: t('steps.business_onboarding.step4'),
      },
      {
        selector: '.sixth-step',
        content: t('steps.business_onboarding.step5'),
      },
      {
        selector: '.seventh-step',
        content: t('steps.business_onboarding.step6'),
      },
    ],

    steps_service: [
      {
        selector: '.first-step',
        content: t('steps.service.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.service.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.service.step2'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.service.step3'),
      },
    ],
    steps_service_onboarding: [
      {
        selector: '.first-step',
        content: t('steps.service_onboarding.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.service_onboarding.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.service_onboarding.step2'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.service_onboarding.step3'),
      },
    ],

    steps_behavior: [
      {
        selector: '.first-step',
        content: t('steps.behavior.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.behavior.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.behavior.step4'),
      },
      {
        selector: '.fourth-step',
        content: t('steps.behavior.step3'),
      },
      {
        selector: '.fifth-step',
        content: t('steps.behavior.step2'),
      },
      {
        selector: '.sixth-step',
        content: t('steps.behavior.step5'),
      }
    ],

    steps_marketplace: [
      {
        selector: '.first-step',
        content: t('steps.marketplace.title'),
      },
    ],

    steps_myIntegrations: [
      {
        selector: '.first-step',
        content: t('steps.myIntegrations.title'),
      },
    ],

    steps_autoResponse: [
      {
        selector: '.first-step',
        content: t('steps.autoResponse.title'),
      },
      {
        selector: '.second-step',
        content: t('steps.autoResponse.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.autoResponse.step2'),
      },
      {
        selector: '.fourth-step',
        content: (
          <div style={{ textAlign: 'center', maxWidth: '300px' }}>
            <img 
              src="/images/deleteKnowledge.png" 
              alt="Knowledge Management" 
              style={{ 
                width: '300px', 
                height: '100px', 
                borderRadius: '8px',
                marginBottom: '16px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                display: 'block',
                margin: '0 auto 16px auto'
              }} 
            />
            <p style={{ 
              margin: 0, 
              fontSize: '14px', 
              lineHeight: '1.5',
              textAlign: 'right',
              direction: 'rtl'
            }}>
              {t('steps.autoResponse.step3')}
            </p>
          </div>
        ),
      },
    ],
    
    steps_conversation: [
      {
        selector: '.first-step',
        content: t('steps.conversation.title'),
      },
    ],

    steps_subscription: [
      {
        selector: '.first-step',
        content: t('steps.subscription.step1'),
      },
      {
        selector: '.second-step',
        content: t('steps.subscription.step2'),
      },
    ],

    steps_chatbox: [
      {
        selector: '.first-step',
        content: t('steps.chatbox.step1'),
      },
      {
        selector: '.third-step',
        content: t('steps.chatbox.step3'),
      },
      {
        selector: '.second-step',
        content: t('steps.chatbox.step2'),
      }
    ],

    steps_dashboard: [
      {
        selector: '.dashboard-help-button',
        content: t('steps.dashboard.helpButton'),
      },
      {
        selector: '.dashboard-video-button',
        content: t('steps.dashboard.videoButton')
      },
      {
        selector: '.dashboard-hamburger-menu',
        content: t('steps.dashboard.hamburgerMenu'),
      },
      {
        selector: '.dashboard-sidebar',
        content: t('steps.dashboard.sidebar'),
      },
      {
        selector: '.dashboard-subscription-info',
        content: t('steps.dashboard.subscriptionInfo'),
      },
      {
        selector: '.dashboard-logout-button',
        content: t('steps.dashboard.logoutButton'),
      },
      // {
      //   selector: '.dashboard-user-info',
      //   content: t('steps.dashboard.userInfo'),
      // },
      {
        selector: '.dashboard-active-channels',
        content: t('steps.dashboard.activeChannels'),
      },
      {
        selector: '.dashboard-knowledge-count',
        content: t('steps.dashboard.knowledgeCount'),
      },
      {
        selector: '.dashboard-token-usage',
        content: t('steps.dashboard.tokenUsage'),
      },
      {
        selector: '.dashboard-conversations',
        content: t('steps.dashboard.conversations'),
      },
      {
        selector: '.dashboard-conversations-last-7-days',
        content: t('steps.dashboard.conversationsLast7Days'),
      },
      {
        selector: '.dashboard-active-integrations',
        content: t('steps.dashboard.activeIntegrations'),
      },
      {
        selector: '.dashboard-recent-payments',
        content: t('steps.dashboard.recentPayments'),
      },
    ],
  };
};